<template>
  <el-container direction="vertical" id="ejsinoInsureDetails">
    <div>
      <iframe
        id="iframeId" :style="height" :src="url" frameborder="0" scrolling="auto">
      </iframe>
    </div>
    <el-menu class="el-menu-vertical" :collapse="false" :class="{insureInfo: true}">
      <el-menu-item index="1" @click="checkDetails(1)">
          <span slot="title">投保流程</span>
      </el-menu-item>
      <el-menu-item index="2" @click="checkDetails(2)">
        <span slot="title">保费支付说明</span>
      </el-menu-item>
      <el-menu-item index="3" @click="checkDetails(3)">
        <span slot="title">发票申请流程</span>
      </el-menu-item>
      <el-menu-item index="4" @click="checkDetails(4)">
        <span slot="title">保全流程</span>
      </el-menu-item>
    </el-menu>
  </el-container>
</template>

<script>
  export default {
    name: "ejsinoInsureDetails",
    data() {
      return {
        // -- iframe页面适应style
        height: 'height:100%;position:absolute;left:0;right:0;top:120px;bottom:0;width:100%;background:#fff;overflow-y:hidden;',
        // -- iframe页面src
        url: '',
        orderToken: '',
        endorOrderToken: '',
        invoiceType: '',
        orderEndoInfo: {},
        productId: this.$route.query.productId,
        // -- iframe计数判断
        loadNum : 1,
        insCompanyId: null,
      }
    },
    methods: {
      // -- 获取iframe高度
      getHeight() {
        this.height = this.height.replace("height:100%", "height:" + document.getElementById("iframeId").offsetHeight + "px").replace("position:absolute;", "");
      },
      // -- 获取e超市产品投保链接
      getEjsinoUrl() {
        let params = {};
        params.productId = this.productId;
        if (this.$$.isValidObj(this.$route.query.orderToken)) params.orderToken = this.orderToken;
        if (this.$$.isValidObj(this.$route.query.endorOrderToken)) params.endorOrderToken = this.endorOrderToken;
        if (this.$$.isValidObj(this.$route.query.isEndorOrder)) params.isEndorOrder = true;
        this.axios.post('/management/mobileInsuranceInfo/getEjsinoUrl', params).then((response) => {
          if (response.data.success) {
            if(this.$$.isValidObj(response.data.datas.success) && !response.data.datas.success){
              this.$message.error(response.data.datas.msg);
              this.$router.push({name: 'personnelManagement', query: {insuranceIsGroup : "4"}});
            }
            this.url = response.data.datas.url;
            this.orderToken = response.data.datas.orderToken;
            if( this.$$.isValidObj(response.data.datas.orderEndoInfo) ) this.orderEndoInfo = response.data.datas.orderEndoInfo;
            this.insCompanyId = response.data.datas.insCompanyId;
          }
        });
      },
      // -- 获取e超市发票相关链接
      getEjsinoInvoiceUrl() {
        let params = {};
        params.invoiceType = this.invoiceType;
        if (this.$$.isValidObj(this.orderToken)) params.orderToken = decodeURIComponent(this.orderToken);
        if (this.$$.isValidObj(this.endorOrderToken)) params.endorOrderToken = decodeURIComponent(this.endorOrderToken);
        this.axios.post('/management/mobileInsuranceInfo/requestInvoiceData', null, {params}).then((response) => {
          if (response.data.success) {
            this.url = response.data.datas.url;
          } else {
            this.$message.error(data.msg);
          }
        });
      },
      // Q&A
      checkDetails(index) {
        let url = this.$router.resolve({
          path: '/qnaDetails',
          query: { insCompanyId: this.insCompanyId, index }
        });
        window.open(url.href, '_blank');
      },
    },
    mounted() {
      this.url = '';
      this.getHeight();
      if (!this.$$.isValidObj(this.$route.query.productId) && !this.$$.isValidObj(this.$route.query.orderToken) && !this.$$.isValidObj(this.$route.query.endorOrderToken)
      ) {
        this.$confirm('当前订单参数错误，请重新进入~', '温馨提示：', {
          showClose: false,
          closeOnClickModal: false,
          center: true,
          showCancelButton: false,
          confirmButtonText: '确认',
        }).then(() => {
          this.$router.push({name: 'insuranceList'});
        });
      }
      if (this.$$.isValidObj(this.$route.query.productId) && !this.$$.isValidObj(this.$route.query.orderToken) && !this.$$.isValidObj(this.$route.query.endorOrderToken)) {
        this.getEjsinoUrl();
      } else if (this.$$.isValidObj(this.$route.query.productId) && this.$$.isValidObj(this.$route.query.orderToken)) {
        this.orderToken = this.$route.query.orderToken;
        this.getEjsinoUrl();
      } else if (this.$$.isValidObj(this.$route.query.invoiceType) && this.$$.isValidObj(this.$route.query.orderToken)) {
        this.orderToken = this.$route.query.orderToken;
        this.invoiceType = this.$route.query.invoiceType;
        this.getEjsinoInvoiceUrl();
      } else if (this.$$.isValidObj(this.$route.query.invoiceType) && this.$$.isValidObj(this.$route.query.endorOrderToken)) {
        this.endorOrderToken = this.$route.query.endorOrderToken;
        this.invoiceType = this.$route.query.invoiceType;
        this.getEjsinoInvoiceUrl();
      } else if(!this.$$.isValidObj(this.$route.query.invoiceType) && this.$$.isValidObj(this.$route.query.endorOrderToken)){
        this.endorOrderToken = this.$route.query.endorOrderToken;
        this.getEjsinoUrl();
      }
    }
  }
</script>

<style scoped>
  .insureInfo{
    position: fixed;
    right: .5rem;
    bottom: 12rem;
  }

  /deep/ .el-menu-vertical {
    background: #f5f5f5;
    box-shadow: 0px 2px 5px 2px rgba(50, 45, 45, 0.14);
  }

  .el-menu-item{
    height: 46px;
    line-height: 46px;
    min-width: 100%;
    text-align: center;
    color: #169fed!important;
    padding-left: 10px!important;
    padding: 0 10px;
  }

  /deep/ .el-submenu__title{
    min-width: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/employerInsurance/ejsinoInsureDetails.vue